module.exports = function getResource(label, vars = []) {
    const resources = {
        reset: 'Réinitialiser',
        filter: 'le filtre'
    };
    return resources[label];
};
